import { render } from "./PawChoiceQuestion.vue?vue&type=template&id=a0c6e1ba"
import script from "./PawChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./PawChoiceQuestion.vue?vue&type=script&lang=js"

import "./PawChoiceQuestion.vue?vue&type=style&index=0&id=a0c6e1ba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__